.controls { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; justify-content: flex-end; }

/* Both states, side by side. Showing only the portal's would let "Expired"
   read as a failure when three quarters of those lines delivered in full. */
.states { display: inline-flex; gap: 6px; align-items: center; }

/* An unbooked appointment on an open PO is the actionable state on this page,
   so it is the one word that is coloured. */
.warn { color: var(--badge-high-text); font-weight: 500; }
